<div class="section">
    <!-- container -->
    <div class="containercheckout">
        <!-- row -->
        <div class="row">
            <!-- Order Details -->
            <div class="col-md order-details">
                <div class="section-title text-center">
                    <h3 class="title">Order {{ order.orderId }}</h3>
                    <h5 style="padding-top: 8px">Date Ordered: {{ order.createdDate | date: 'dd-MMM-yyyy HH:mm'  }}</h5>
                    <h5>Status: {{ order.currentPastelStatus }}</h5>
                </div>
                <div class="order-summary">
                    <div class="order-col">
                        <div><strong>PRODUCT</strong></div>
                        <div><strong>TOTAL</strong></div>
                    </div>
                    <div class="order-products">
                        <div
                            class="order-col"
                            *ngFor="let item of order.orderLines"
                        >
                            <div>{{item.quantity}} x {{ item.productDescription }}</div>
                            <div ></div>
                            <div > {{ item.totalPriceExcl | currency: "R" }}</div>
                               
                        </div>
                    </div>
                    <div class="order-col">
                        <div>Shipping</div>
                        <div><strong>FREE</strong></div>
                    </div>
                    <div class="order-col">
                        <div><strong>TOTAL (excl. VAT)</strong></div>
                        <div>
                            <strong>{{
                                order.totalPriceExcl | currency: "R"
                            }}</strong>
                        </div>
                    </div>
                    <div class="order-col">
                      <div><strong>TOTAL (incl. VAT)</strong></div>
                      <div>
                          <strong class="order-total">{{
                              order.totalPriceIncl | currency: "R"
                          }}</strong>
                      </div>
                  </div>
                </div>
                <br />
            </div>
        </div>
    </div>
</div>

<div class="spinner-wrapper" *ngIf="isLoading">
    <app-spinner></app-spinner>
</div>
